'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var transformHealthChecksScans = exports.transformHealthChecksScans = function transformHealthChecksScans(items, type) {
	var results = Array.isArray(items) && items || [{ name: 'No Results Found.', type: '', isSectionHeader: true }];
	return results.map(function (item) {
		return _extends({}, item, {
			type: type || item.type
		});
	});
};